<div class="policy-field" [formGroup]="settingsFormGroup">
    <div class="policy-field-text">
        <div class="policy-field-text-title">
            {{ title | labelsProvider }}
        </div>
        <div class="policy-field-text-description">
            {{ description | labelsProvider }}
        </div>
    </div>
    <div class="policy-field-box">
        <app-numeric-field [value]="value" [editable]="editable" [formControlName]="formControlName">
        </app-numeric-field>
        <app-effective-policy-settings-button class="policy-field-effective-policy-settings-button"
            [platform]="platform" [effectivePolicySetting]="effectivePolicySetting">
        </app-effective-policy-settings-button>
    </div>
</div>
